import BrButton from '@govbr/react-components/lib/BrButton';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import imgMoca1 from '../../../assets/img/como-cadastrar-moca1.svg';
import imgPagina1 from '../../../assets/img/tutorial-pre-cadastro-pagina1.svg';
import { selectGovBr } from '../../../auth/authSlice';
import styles from './TutorialConsultaEscolaridade.module.css';
import { Checkbox } from '@material-ui/core';

const TutorialConsultaEscolaridade: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const govBrLogado = useAppSelector(selectGovBr).logado;

  const [isNaoExibirNovamente, setIsNaoExibirNovamente] = useState(false);

  const handleOnChangeNaoExibirNovamente = () => {
    setIsNaoExibirNovamente(!isNaoExibirNovamente);
  };

  const concluir = () => {
    if (isNaoExibirNovamente) {
      localStorage.setItem('cadunico/tutorial-consulta-escolaridade-nao-exibir', 'true');
    }

    if (location.state?.readOnly) {
      // Se o usuário estiver abrindo o tutorial somente leitura, não redireciona para
      // consulta de escolaridade atualizada.
      return history.goBack();
    }

    // Execução padrão de redirecionar para a tela de consulta de escolaridade atualizada.
    if (!govBrLogado) {
      localStorage.setItem('cadunico/redirect', '/consultaEscolaridade');
    }
    history.replace('/consultaEscolaridade');
  };

  return (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Consulta de escolaridade atualizada</div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            O Governo Federal passou a utilizar as informações do Sistema Presença (Ministério
            da Educação) para verificar a atualidade dos dados de escolaridade declarados pelo
            Responsável Familiar (RF) para os integrantes da sua família.
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Por enquanto, a atualização automática dos dados de escolaridade será apenas para
            pessoas acompanhadas pelo Sistema Presença, ou seja, pessoas entre 04 a 17 anos e
            beneficiárias do Programa Bolsa Família (PBF).
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Você pode acompanhar aqui quais dados foram atualizados.
          </div>

          <div className={styles.footerWrapper}>
            <div
              className={styles.checkboxWrapper}
              style={location.state?.readOnly ? { display: 'none' } : {}}
            >
              <Checkbox
                color="primary"
                onChange={handleOnChangeNaoExibirNovamente}
                checked={isNaoExibirNovamente}
                className={styles.checkbox}
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
              <span className={styles.checkboxText} onClick={handleOnChangeNaoExibirNovamente}>
                Não exibir novamente
              </span>
            </div>
            <div className={styles.botaoWrapper}>
              <BrButton className={styles.botao} onClick={() => concluir()}>
                Concluir
              </BrButton>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
      </div>
    </div>
  )
};

export default TutorialConsultaEscolaridade;
